const _ = require('lodash');
const React = require('react');

const CastManagementMixin = {
    /**
     * Convert seconds to a string like '36:02'
     *
     * @todo this can be done better
     * @param seconds
     * @returns {string}
     */
    toMinutesString: function (seconds) {
        const secondsRound = Math.round(seconds); // Round to nearest int
        const minutes = Math.floor(secondsRound / 60);
        const remainder = secondsRound - (minutes * 60);
        const minutesString = minutes < 10 ? '0' + minutes.toString() : minutes.toString();
        const secondsString = remainder < 10 ? '0' + remainder.toString() : remainder.toString();
        return minutesString + ':' + secondsString;
    },

    /**
     * Calculate track selection progress
     *
     * @returns {{width: string}}
     */
    progressBarWidth: function (cast) {
        const progress = this.selectedTracksLength(cast.tracks) / cast.target_duration * 100;
        const width = (progress > 1 ? progress : 1) + '%';
        return {width: width};
    },

    /**
     * Tally up the total duration of selected tracks
     *
     * @returns {number}
     */
    selectedTracksLength: function (tracks) {
        const durations = _.map(tracks, 'duration');

        let total = 0;
        durations.forEach(function (duration) {
            total += duration;
        });

        return total;
    }
};

module.exports = CastManagementMixin;
